import React, { useEffect } from "react";
import { Card, Row, Col, Button, List } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../AdjustmentRecordSlice";
import {
  fetchGroups,
  fetchCategories,
  fetchItems,
  fetchUsers,
} from "../../../store/commonThunks/lookups";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import { SearchOutlined } from "@ant-design/icons";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";
import { fetchAdjustmentRecord } from "../AdjustmentRecordThunk";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const AdjustmentRecordFilters = () => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.adjustmentRecord);
  const lookups = useSelector((state) => state.lookups);
  useDefaultDateRange(setFilters, filters, "today");
  const dynamicSpan = filters.filterType === "By Tag" ? 3 : 4;
  useEffect(() => {
    dispatch(fetchGroups());
    dispatch(fetchCategories());
    dispatch(fetchItems());
    dispatch(fetchUsers());
  }, [dispatch]);

  const handleFilterChange = (field, value) => {
    dispatch({ type: "adjustmentRecord/resetList" });
    dispatch(setFilters({ [field]: value }));
  };

  const handleSubmit = () => {
    dispatch(
      fetchAdjustmentRecord({
        selectedFilterType: filters.filterType,
        selectedRecordType: filters.recordType,
        filters,
      })
    );
  };

  const renderExtraField = () => {
    switch (filters.filterType) {
      case "By Item":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Item</label>
            <SearchListAutoComplete
              entityType="item"
              optionsList={lookups.items.map((e) => ({
                sale_id: e.item_id,
                display_text: e.item_name,
              }))}
              onSelect={(obj) => handleFilterChange("itemId", obj?.sale_id)}
              placeholder="Item"
              showAddNew={false}
            />
          </Col>
        );

      case "By Group":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Group</label>
            <SearchListAutoComplete
              entityType="group"
              optionsList={lookups.groups.map((e) => ({
                sale_id: e.group_id,
                display_text: e.group_name,
              }))}
              onSelect={(obj) => handleFilterChange("groupId", obj?.sale_id)}
              placeholder="Group"
              showAddNew={true}
            />
          </Col>
        );

      case "By Category":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Category</label>
            <SearchListAutoComplete
              entityType="category"
              optionsList={lookups.categories.map((e) => ({
                sale_id: e.category_id,
                display_text: e.category_name,
              }))}
              onSelect={(obj) => handleFilterChange("categoryId", obj?.sale_id)}
              placeholder="Category"
              showAddNew={true}
            />
          </Col>
        );

      case "By User":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search User</label>
            <SearchListAutoComplete
              entityType="user"
              optionsList={lookups.users.map((e) => ({
                sale_id: e.id,
                display_text: e.full_name,
              }))}
              onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
              placeholder="User"
            />
          </Col>
        );

      default:
        return null;
    }
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} wrap style={{ alignItems: "center" }}>
        {/* 🔹 Filter Type */}
        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4} >
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All", display_text: "All" },
              { sale_id: "By Item", display_text: "By Item" },
              { sale_id: "By Group", display_text: "By Group" },
              { sale_id: "By Category", display_text: "By Category" },
              { sale_id: "By User", display_text: "By User" },
            ]}
            value={{
              value: filters.filterType,
              label: filters.filterType,
            }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {renderExtraField()}
        {filters.filterType === "All" || filters.filterType === "By User" ? (
          <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4} >
            <label>Record Type</label>
            <SearchListAutoComplete
              optionsList={[
                { sale_id: "with item", display_text: "With Item" },
                { sale_id: "without item", display_text: "Without Item" },
              ]}
              value={
              filters.recordType
                ? { value: filters.recordType, label: filters.recordType === "with item"? "With Item" : "Without Item"}
                : undefined
            }
              onSelect={(obj) => handleFilterChange("recordType", obj?.sale_id)}
              placeholder="Record Type"
              showAddNew={false}
            />
          </Col>
        ) : (
          ""
        )}
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24} sm={12} md={9} xl={3}
          style={{ paddingTop: "1.4rem" }}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            style={{height: 35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  `}</style>
    </Card>
  );
};

export default AdjustmentRecordFilters;
